/* Pages locales « Où acheter Ozentya » : une page par département / territoire, construite uniquement à partir des revendeurs réels.
 * Pas d'import : ce fichier est aussi chargé par scripts/prerender.mjs. */
const PREP = {
  "75": "à Paris", "77": "en Seine-et-Marne", "78": "dans les Yvelines", "91": "en Essonne", "92": "dans les Hauts-de-Seine", "93": "en Seine-Saint-Denis",
  "94": "dans le Val-de-Marne", "95": "dans le Val-d'Oise", "60": "dans l'Oise", "13": "dans les Bouches-du-Rhône", "69": "dans le Rhône", "34": "dans l'Hérault",
  "971": "en Guadeloupe", "972": "en Martinique", "973": "en Guyane",
};
const OUTRE_MER = new Set(["971", "972", "973", "974", "976"]);

const slugify = (s) => String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function localZones(resellers) {
  const by = new Map();
  for (const r of resellers) {
    if (!by.has(r.dept)) by.set(r.dept, { dept: r.dept, name: r.dept_name, items: [] });
    by.get(r.dept).items.push(r);
  }
  return [...by.values()].sort((a, b) => b.items.length - a.items.length || a.dept.localeCompare(b.dept)).map((z) => {
    const slug = /^\d/.test(z.dept) && !OUTRE_MER.has(z.dept) ? `${slugify(z.name)}-${z.dept}` : slugify(z.name);
    const cities = [...new Set(z.items.map((r) => r.city))];
    const prep = PREP[z.dept] || (z.name === "Sénégal" ? "au Sénégal" : `en ${z.name}`);
    const n = z.items.length;
    const where = /^\d/.test(z.dept) && z.dept !== "75" ? `${z.name} (${z.dept})` : z.name;
    const online = OUTRE_MER.has(z.dept) ? "Vous pouvez aussi commander en ligne : livraison Colissimo Outre-mer à 11,90 € jusqu'à 30 € d'achat, puis 14,99 €."
      : /^\d/.test(z.dept) ? "Vous pouvez aussi commander en ligne : livraison gratuite en Point Relais ou Locker Mondial Relay partout en France métropolitaine." : "";
    return {
      ...z, slug, path: `/ou-acheter/${slug}`, cities, prep, where, online,
      title: `Où acheter Ozentya ${prep} : ${n} revendeur${n > 1 ? "s" : ""} | Ozentya`,
      description: `Trouvez les soins Ozentya pour cheveux afro, crépus et locks ${prep} : ${n} salon${n > 1 ? "s" : ""} et boutique${n > 1 ? "s" : ""} à ${cities.slice(0, 4).join(", ")}${cities.length > 4 ? "…" : ""}. Adresses et téléphones.`,
      h1: `Où acheter Ozentya ${prep}`,
      intro: `Les soins Ozentya pour cheveux afro, crépus, naturels, locks et barbe sont disponibles chez ${n} revendeur${n > 1 ? "s" : ""} ${prep}${cities.length > 1 ? `, à ${cities.join(", ")}` : ` (${cities[0]})`}. Les stocks varient d'un magasin à l'autre : appelez avant de vous déplacer.`,
    };
  });
}
